import React from "react";
import AppLink from "./AppLink";
import { baseUrl, signupPage } from "../../Constants";

export const BetaChip = () => {
    const styles = {
        section: {
            position: 'relative',
            width: '100%',
            maxWidth: '276px',
            height: '32px',
            margin: '0 auto',
            opacity: 1,
            transform: 'translateY(0)'
        },
        chip: {
            width: '100%',
            height: '100%',
            background: '#181818',
            borderRadius: '999px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            padding: '0 11px',
            boxSizing: 'border-box'
        },
        leftGroup: {
            display: 'flex',
            alignItems: 'center',
            gap: '6px'
        },
        dot: {
            width: '8px',
            height: '8px',
            background: '#00DA00',
            borderRadius: '50%'
        },
        title: {
            fontFamily: "Inter, Helvetica, Arial, sans-serif",
            fontWeight: 600,
            color: '#ffffff',
            fontSize: '9pt',
            letterSpacing: 0,
            lineHeight: 'normal'
        },
        image: {
            width: '17px',
            height: '17px',
            objectFit: 'cover'
        }
    };

    return (
        <section style={styles.section} data-model-id="272:9">
            <AppLink href={signupPage} style={{ textDecoration: 'none' }}>
                <div style={styles.chip}>
                    <div style={styles.leftGroup}>
                        <div style={styles.dot} />
                        <h1 style={styles.title}>Beta already available for free</h1>
                    </div>

                    <img
                        style={styles.image}
                        alt="Image"
                        src="images/arrow-right.png"
                    />
                </div>
            </AppLink>
        </section>
    );
};